{
  "title": "Dashboard",
  "greeting": "Good morning, {{name}}",
  "greetingAnonymous": "Good morning",
  "scope": {
    "onlyMine": "Only mine",
    "workspaceTrigger": "Change workspace",
    "teamTrigger": "Change team",
    "allWorkspaces": "All workspaces",
    "allTeams": "All teams",
    "searchPlaceholder": "Search…",
    "pickerEmpty": "Nothing found"
  },
  "summary": {
    "mine": "{{attention}} things need you · {{shoots}} of your shoots in the next {{days}} days",
    "workspace": "{{attention}} things need attention · {{shoots}} shoots in the next {{days}} days",
    "organization": "{{attention}} things need attention across the organization · {{shoots}} shoots in the next {{days}} days",
    "team": "{{attention}} things need attention in this team · {{shoots}} shoots in the next {{days}} days",
    "total": "Open items"
  },
  "sections": {
    "attention": "Needs attention",
    "attentionHint": "Most urgent first; rows disappear once the work is done",
    "timeline": "Next {{days}} days",
    "timelineHint": "Shoot dates lane by lane; point at a bar for crew and status",
    "workspaces": "Workspaces",
    "workspacesHint": "Where the work and the risk sit right now",
    "summaryHint": "Each kind opens the queue on its tab",
    "later": "Later in the window",
    "laterHint": "The shoots after tomorrow"
  },
  "shoot": {
    "open": "Open production",
    "untitled": "Untitled production",
    "crewMeter": "Crew booked",
    "callsheetMeter": "Callsheet",
    "callsheet_shared": "Shared",
    "callsheet_building": "Building",
    "callsheet_missing": "Not started",
    "crewOpen": "Still open",
    "crewBooked": "Booked",
    "crewUnnamedRole": "Unnamed role",
    "crewMore": "and {{count}} more"
  },
  "status": {
    "active": "Shooting",
    "ready": "Ready",
    "resourcing": "Resourcing",
    "alert": "At risk",
    "draft": "No roles yet",
    "complete": "Wrapped"
  },
  "when": {
    "today": "Today",
    "tomorrow": "Tomorrow",
    "inDays_one": "in {{count}} day",
    "inDays_other": "in {{count}} days"
  },
  "stats": {
    "shoots": "Shoots",
    "shootsHint": "in the next {{days}} days",
    "rolesFilled": "Roles booked",
    "rolesFilledHint": "{{booked}} of {{total}} roles",
    "pencils": "Pencils to confirm",
    "pencilsHint": "holds in the next {{days}} days",
    "attention": "Needs attention",
    "attentionHint": "items waiting for someone",
    "availability": "Availability asks",
    "availabilityHint": "sent, still unanswered"
  },
  "filters": {
    "all": "All",
    "resourcing": "Resourcing",
    "availability": "Availability",
    "callsheets": "Callsheets",
    "bookings": "Bookings"
  },
  "attention": {
    "ariaLabel": "Items that need attention",
    "empty": "Nothing waiting here.",
    "rolesUnfilled": {
      "title_one": "{{count}} unfilled role on {{production}}",
      "title_other": "{{count}} unfilled roles on {{production}}",
      "description": "Shoot starts {{date}}",
      "action": "Find crew"
    },
    "callsheetMissing": {
      "title": "No callsheet for {{production}} yet",
      "description_one": "{{count}} crew member booked",
      "description_other": "{{count}} crew members booked",
      "action": "Open"
    },
    "callsheetBuilding": {
      "title": "Callsheet for {{production}} is not shared yet",
      "description": "Recipients have no call details",
      "action": "Open"
    },
    "availability": {
      "title": "{{resource}} has not answered yet",
      "someone": "This resource",
      "description": "Availability asked for {{range}}",
      "due_one": "waiting {{count}} day",
      "due_other": "waiting {{count}} days",
      "dueToday": "asked today",
      "action": "Open resource"
    },
    "pencils": {
      "title_one": "{{count}} pencilled booking needs confirming",
      "title_other": "{{count}} pencilled bookings need confirming",
      "description": "Holds in the next {{days}} days",
      "due": "This window",
      "action": "Open bookings"
    }
  },
  "timeline": {
    "empty": "No shoots in this window.",
    "unassigned": "No team",
    "crew": "Crew booked {{booked}} / {{total}}",
    "demandBooked_one": "{{count}} person booked",
    "demandBooked_other": "{{count}} people booked",
    "demandUnfilled_one": "{{count}} role still unfilled",
    "demandUnfilled_other": "{{count}} roles still unfilled",
    "legend": {
      "active": "Shooting",
      "ready": "Ready",
      "resourcing": "Resourcing",
      "alert": "At risk"
    },
    "openRoles": "{{count}} open"
  },
  "workspaces": {
    "shoots_one": "{{count}} shoot in the next {{days}} days",
    "shoots_other": "{{count}} shoots in the next {{days}} days",
    "rolesFilled": "roles booked",
    "attention": "{{value}} to fix",
    "noAttention": "On track",
    "open": "Open",
    "emptyTitle": "No workspaces yet",
    "empty": "This organization has no workspaces yet."
  },
  "loadError": "The dashboard could not be loaded.",
  "demo": {
    "toggle": "See the dashboard's potential",
    "bannerTitle": "You are looking at sample data",
    "bannerMessage": "A busy fortnight, made up to show what this dashboard does once your shoots, crew and callsheets live in Atellio. Links are switched off.",
    "exit": "Back to my data"
  },
  "view": {
    "trigger": "View: {{view}}",
    "menuLabel": "Dashboard view",
    "names": {
      "today": "Today",
      "plan": "Plan",
      "table": "Table",
      "overview": "Overview"
    },
    "descriptions": {
      "today": "What needs you first, then the shoots coming up",
      "plan": "Who shoots when across the window, and crew per day",
      "table": "Every shoot in the window as one list",
      "overview": "The numbers and the next shoots at a glance"
    },
    "answers": {
      "today": "I staff crew and chase confirmations",
      "plan": "I plan who works when",
      "table": "I run many productions at once",
      "overview": "I check that everything is on track"
    },
    "question": "What do you do in Atellio most?",
    "questionHint": "We will lay the dashboard out for it. You can switch any time.",
    "skip": "Skip",
    "pickedHint": "Showing the {{view}} view. Change it any time under View, top right.",
    "pickedHintDismiss": "Got it"
  },
  "table": {
    "title": "Shoots in the next {{days}} days",
    "hint": "Earliest first; open a production from its name",
    "production": "Production",
    "lane": "Team",
    "laneWorkspace": "Workspace",
    "dates": "Dates",
    "status": "Status",
    "crew": "Crew",
    "callsheet": "Callsheet",
    "issues": "Issues",
    "filterAll": "All",
    "filterWithIssues": "With issues",
    "filterThisWeek": "This week",
    "issueCount_one": "{{count}} issue",
    "issueCount_other": "{{count}} issues"
  },
  "day": {
    "hint": "{{count}} crew asked · {{unfilled}} unfilled · pick another date above",
    "empty": "No shoot runs this day."
  },
  "overview": {
    "today": "Today",
    "todayHeadline_one": "{{count}} shoot on set",
    "todayHeadline_other": "{{count}} shoots on set",
    "todayEmpty": "Nothing on set today",
    "atRisk": "At risk",
    "ready": "Crew booked and nothing waiting on you.",
    "laterEmpty": "Nothing else in the window."
  },
  "agenda": {
    "stripLabel": "Days in the window",
    "stripCaption": "Each dot is a shoot · orange means it is at risk",
    "dayShoots_one": "{{count}} shoot",
    "dayShoots_other": "{{count}} shoots",
    "dayAtRisk": "{{count}} at risk",
    "laterOpen_one": "Later in the window: {{count}} more shoot, {{open}} with something open.",
    "laterOpen_other": "Later in the window: {{count}} more shoots, {{open}} with something open.",
    "laterReady_one": "Later in the window: {{count}} more shoot, on track.",
    "laterReady_other": "Later in the window: {{count}} more shoots, all on track.",
    "seePlan": "See the full plan",
    "title": "Coming up",
    "onSet": "On set today",
    "onSetShoots_one": "{{count}} shoot",
    "onSetShoots_other": "{{count}} shoots",
    "onSetPeople_one": "{{count}} person",
    "onSetPeople_other": "{{count}} people",
    "onSetReady": "all ready",
    "onSetOpen_one": "{{count}} needs something",
    "onSetOpen_other": "{{count}} need something",
    "noCrew": "No crew planned yet",
    "onSetMore_one": "{{count}} more on set today",
    "onSetMore_other": "{{count}} more on set today"
  },
  "create": {
    "production": "New production"
  }
}
